<template>
  <v-container v-if="!containerInitLoading && machineModel" fluid style="height: inherit" class="pa-0">
    <v-row align="stretch" no-gutters>
      <v-col style="border-bottom: 1px solid var(--v-disabled-base);">
        <MachineModelDetails :machineModel="machineModel" :saveMethod="saveChanges">
        </MachineModelDetails>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <template v-if="ProductPortalEnabled">
        <!-- <v-divider vertical style="z-index: 1;" />  -->

        <v-col style="background-color: rgb(248, 248, 248) !important; min-width: 290px; max-width: 290px" class="pa-3 pt-1">
          <MachineModelSyncDetails :machineModel="machineModel" :saveMethod="saveChanges">
          </MachineModelSyncDetails>
        </v-col>
        <v-divider vertical style="z-index: 1;" />
      </template>

      <v-col>
        <v-card class="pa-4" flat>
          <MachineModelJobTypePieChart :modelId="machineModelId">
          </MachineModelJobTypePieChart>
        </v-card>
      </v-col>
      <!-- 
      <v-col>
        <v-card class="pa-4" flat>
          <h3 class="text-center">Average service rate last 12 months</h3>
          <p class="text-center">Number of jobs, balanced by number of machines of each model.</p>
          <MachineModelServiceRateChart :modelId="machineModelId">
          </MachineModelServiceRateChart>
        </v-card>
      </v-col>
      -->
      <v-col>
        <v-card class="pa-4" flat>
          <MachineModelFailureCodePieChart :modelId="machineModelId">
          </MachineModelFailureCodePieChart>
        </v-card>
      </v-col>
    </v-row>


    <!-- 
    <v-divider></v-divider>

    <v-row no-gutters>
      <v-col>
        <VariationsCard :list="machineModel && machineModel.Variations ? machineModel.Variations : []"
          :parent="machineModel && machineModel.Parent">
        </VariationsCard>
      </v-col>
    </v-row>
    -->
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
//import VariationsCard from "@/views/pim/machinemodels/MachineModelVariationsCard.vue";
import MachineModelDetails from "./MachineModelDetails.vue";
import MachineModelFailureCodePieChart from "./MachineModelFailureCodePieChart.vue";
//import MachineModelServiceRateChart from "./MachineModelServiceRateChart.vue";
import MachineModelJobTypePieChart from "./MachineModelJobTypePieChart.vue";
import MachineModelSyncDetails from "./MachineModelSyncDetails.vue";

export default {
  name: "ViewMachineModelInfo",
  props: {
    containerInitLoading: Boolean, //getting container data for the first time, show skeletonloader
    containerLoading: Boolean, //loading container data update, do so in the background with small indicator
    containerItem: Object, //container data
  },
  components: {
    MachineModelDetails,
    MachineModelSyncDetails,
    MachineModelFailureCodePieChart,
   // MachineModelServiceRateChart,
    MachineModelJobTypePieChart,
    //VariationsCard,
  },
  mixins: [clientAPI],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {
    async saveChanges(obj) {
      var copy = Object.assign({}, obj);
      copy.timeStamp = undefined;
      copy.loading = undefined;
      copy.silentloading = undefined;
      const file = copy.newImage;
      copy.newImage = undefined;
      const dto = Object.assign({}, copy);
      await this.changeModel(dto, file)
        .then((response) => {
          this.machineModel = response;
        })
        .catch((exception) => {
          console.error(exception);
        });
    },
  },

  computed: {
    machineModelId() {
      return this.$route.params.modelId;
    },

    machineModel: {
      get() {
        return this.containerItem;
      },
      set(value) {
        this.$emit('SetContainerItem', value);
      }
    },

    ProductPortalEnabled() {
      return !!this.$store.state.GlobalSettings.ProductPortalSettings;
    },
  },

  watch: {},
};
</script>


<style lang='scss'></style>